export default __webpack_public_path__ + "static/media/ask.76996ec3.png";